import { Pipe, PipeTransform } from '@angular/core';
import { ICollapsedColumn } from "libraries/component/table/configurable-table/configurable-table.component";

@Pipe({
    name: 'isVisibleRow',
})

export class IsVisibleRowPipe implements PipeTransform {
    public transform(rowIndex: number, collapserRef: string, collapsedRow: ICollapsedColumn[]): boolean {
        if (!collapserRef) {
            return true;
        }
        return collapsedRow.findIndex((item: ICollapsedColumn): boolean => item.bookingIndex === rowIndex && item.collapserRef === collapserRef) > -1;
    }
}
